/**
 * useWaiting.jsx
 * How many comments and messages are waiting for a reply.
 *
 * Polled once, in App, and handed to both the sidebar and the phone tab bar —
 * two components each running their own timer would double the requests.
 *
 * Dependencies: services/api.js, react-router-dom
 */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../services/api.js';

export function useWaiting() {
  const [waiting, setWaiting] = useState({ comments: 0, messages: 0, inbox: 0 });
  const here = useLocation().pathname;

  useEffect(() => {
    let stopped = false;
    const check = () =>
      api.inbox
        .count()
        .then((d) => {
          if (stopped) return;
          const comments = d.comments ?? d.unanswered ?? 0;
          const messages = d.messages ?? 0;
          // `inbox` is what the single sidebar entry shows now that Comments
          // and Messages are one screen. The two are kept because the phone
          // tab bar and anything else may still want them apart.
          setWaiting({ comments, messages, inbox: comments + messages });
        })
        .catch(() => {});

    check();
    // Comments are pulled by the cron every minute, so checking more often
    // than that would only add requests, not news.
    const timer = setInterval(check, 60_000);
    return () => {
      stopped = true;
      clearInterval(timer);
    };
    // Re-checked on navigation too, so replying makes the badge drop at once.
  }, [here]);

  return waiting;
}
